"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CaptureThumbnail',
    image: 'c-CaptureThumbnail__Image',
    overlay: 'c-CaptureThumbnail__Overlay',
    selectable: 'c-CaptureThumbnail__Image--selectable',
    selected: 'c-CaptureThumbnail__Image--selected',
    crosshair: 'c-CaptureThumbnail__Crosshair',
    truesize: 'c-CaptureThumbnail__truesize',
    photomeasure: 'c-CaptureThumbnail__photomeasure',
    date: 'c-CaptureThumbnail__date',
    hiddenCapture: 'c-CaptureThumbnail_hiddenCapture'
};
var THUMBNAIL_SIZE = 180;
var THUMBNAIL_SIZE_PX = "".concat(THUMBNAIL_SIZE, "px");
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        position: 'relative',
        'min-width': THUMBNAIL_SIZE_PX,
        'min-height': THUMBNAIL_SIZE_PX,
        'max-width': THUMBNAIL_SIZE_PX,
        'max-height': THUMBNAIL_SIZE_PX,
        border: "".concat(theme_1.DefaultTheme.space(1), " solid transparent")
    },
    _a[exports.CSS.crosshair] = {
        position: 'absolute',
        display: 'block',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        'background-image': (0, theme_1.assetURL)('/images/p2p-dot.png'),
        'background-position': '50%',
        'background-repeat': 'no-repeat',
        'background-size': '40%',
        'pointer-events': 'none'
    },
    _a[exports.CSS.overlay] = {
        position: 'absolute',
        width: 'inherit',
        height: 'inherit'
    },
    _a[exports.CSS.image] = {
        width: 'inherit',
        height: 'inherit',
        position: 'absolute'
    },
    _a[exports.CSS.selectable] = {
        cursor: 'pointer'
    },
    _a[exports.CSS.selected] = {
        cursor: 'default',
        border: "".concat(theme_1.DefaultTheme.space(1), " solid ").concat(theme_1.DefaultTheme.color.accent)
    },
    _a[exports.CSS.truesize] = {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '24px',
        height: '24px',
        'border-radius': '50%',
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'background-image': (0, theme_1.assetURL)('/images/ike_logo_no-text.svg'),
        'background-size': '100%',
        'background-repeat': 'no-repeat'
    },
    _a[exports.CSS.truesize + ' svg'] = {
        width: '24px',
        height: '24px'
    },
    _a[exports.CSS.photomeasure] = {
        position: 'absolute',
        right: "-".concat(theme_1.DefaultTheme.space(2)),
        bottom: "-".concat(theme_1.DefaultTheme.space(2)),
        'background-image': (0, theme_1.assetURL)('/images/ike_logo_no-text.svg'),
        'background-repeat': 'no-repeat',
        'background-position': '50%',
        'background-size': 'cover',
        'border-radius': '50%',
        'background-color': theme_1.DefaultTheme.background.offWhite,
        border: "1px solid ".concat(theme_1.DefaultTheme.background.offWhite),
        width: theme_1.DefaultTheme.space(5),
        height: theme_1.DefaultTheme.space(5)
    },
    _a[exports.CSS.date] = {
        position: 'absolute',
        left: theme_1.DefaultTheme.space(0.5),
        bottom: theme_1.DefaultTheme.space(0.5),
        'background-color': 'rgba(224, 224, 224, 0.75)',
        'font-size': '10px',
        color: theme_1.DefaultTheme.font.color.primary,
        'line-height': 'normal'
    },
    _a[exports.CSS.hiddenCapture + '>:not(i)'] = {
        filter: 'grayscale(100%) brightness(40%)'
    },
    _a);
//# sourceMappingURL=capture.thumbnail.style.js.map